module.exports = __webpack_public_path__ + "static/karen-89d4e743f57c8e2a693cbae9eb0c085a.png";